import Common from "../../Common";

type Body = any

const PbxFlow = class extends Common {
	browse = (companyId: id) =>
		this.get(`/company/${companyId}/pbxflow`)

	read = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/pbxflow/${id}`)

	create = (companyId: id, body: Body) =>
		this.post(`/company/${companyId}/pbxflow`, body)

	update = (companyId: id, id: id, body: Body) =>
		this.patch(`/company/${companyId}/pbxflow/${id}`, body)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbxflow/${id}`)
}

export default PbxFlow
